<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="Insights"></app-header>

    <div class="ui link cards">
        <div class="card" [routerLink]="['missing-data']">
            <div class="content">
                <div class="header">Missing Employee Data</div>
                <div class="description">
                    Any missing employee data may make your reports and charts misleading. See a breakdown of which data
                    is missing.
                </div>
            </div>
        </div>
    </div>
</div>
